import React, { useState } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet, ActivityIndicator } from 'react-native';
import { theme } from '../../shared/theme/theme';
import { useAuth } from '../../infrastructure/auth/AuthContext';
import { HoMeeLogo } from '../components/HoMeeLogo';

export const AuthScreen = () => {
  const { signIn, signUp } = useAuth();
  const [mode, setMode] = useState<'LOGIN' | 'REGISTER'>('LOGIN');
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState<'CUSTOMER' | 'HOMEE'>('CUSTOMER');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async () => {
    setError(null);
    if (!email || !password || (mode === 'REGISTER' && !fullName)) {
      setError('Vyplňte prosím všechna pole.');
      return;
    }
    setLoading(true);
    const err = mode === 'LOGIN'
      ? await signIn(email, password)
      : await signUp(email, password, fullName, role);
    setLoading(false);
    if (err) setError(err);
  };

  return (
    <View style={styles.container}>
      <HoMeeLogo size={110} />
      <Text style={styles.tagline}>Digitální Rolls-Royce on-demand služeb</Text>

      <View style={styles.form}>
        {mode === 'REGISTER' && (
          <TextInput
            style={styles.input}
            placeholder="Celé jméno"
            placeholderTextColor={theme.colors.text.muted}
            value={fullName}
            onChangeText={setFullName}
            autoCapitalize="words"
          />
        )}
        <TextInput
          style={styles.input}
          placeholder="Email"
          placeholderTextColor={theme.colors.text.muted}
          value={email}
          onChangeText={setEmail}
          autoCapitalize="none"
          keyboardType="email-address"
        />
        <TextInput
          style={styles.input}
          placeholder="Heslo"
          placeholderTextColor={theme.colors.text.muted}
          value={password}
          onChangeText={setPassword}
          secureTextEntry
        />

        {mode === 'REGISTER' && (
          <View style={styles.roleRow}>
            <TouchableOpacity
              style={[styles.roleButton, role === 'CUSTOMER' && styles.roleButtonActive]}
              onPress={() => setRole('CUSTOMER')}
            >
              <Text style={[styles.roleText, role === 'CUSTOMER' && styles.roleTextActive]}>Zákazník</Text>
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.roleButton, role === 'HOMEE' && styles.roleButtonActive]}
              onPress={() => setRole('HOMEE')}
            >
              <Text style={[styles.roleText, role === 'HOMEE' && styles.roleTextActive]}>Chci pracovat jako HoMee</Text>
            </TouchableOpacity>
          </View>
        )}

        {error && <Text style={styles.error}>{error}</Text>}

        <TouchableOpacity style={styles.submitButton} onPress={handleSubmit} disabled={loading}>
          {loading
            ? <ActivityIndicator color="#FFF" />
            : <Text style={styles.submitText}>{mode === 'LOGIN' ? 'PŘIHLÁSIT SE' : 'VYTVOŘIT ÚČET'}</Text>}
        </TouchableOpacity>

        <TouchableOpacity onPress={() => { setMode(mode === 'LOGIN' ? 'REGISTER' : 'LOGIN'); setError(null); }}>
          <Text style={styles.switchText}>
            {mode === 'LOGIN' ? 'Nemáte účet? Zaregistrujte se' : 'Už máte účet? Přihlaste se'}
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 30,
  },
  tagline: {
    color: theme.colors.text.muted,
    fontSize: 14,
    marginTop: 8,
    marginBottom: 40,
    textAlign: 'center',
  },
  form: {
    width: '100%',
    maxWidth: 380,
  },
  input: {
    height: 54,
    borderWidth: 1,
    borderColor: theme.colors.border,
    borderRadius: 10,
    paddingHorizontal: 16,
    marginBottom: 14,
    color: theme.colors.text.main,
    backgroundColor: theme.colors.surface,
  },
  roleRow: {
    flexDirection: 'row',
    gap: 10,
    marginBottom: 14,
  },
  roleButton: {
    flex: 1,
    height: 48,
    borderWidth: 1,
    borderColor: theme.colors.border,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
  roleButtonActive: {
    backgroundColor: theme.colors.accent,
    borderColor: theme.colors.accent,
  },
  roleText: {
    color: theme.colors.text.main,
    fontSize: 12,
    fontWeight: '700',
  },
  roleTextActive: {
    color: '#FFF',
  },
  error: {
    color: '#D32F2F',
    marginBottom: 12,
    fontSize: 13,
  },
  submitButton: {
    height: 54,
    backgroundColor: theme.colors.accent,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 6,
  },
  submitText: {
    color: '#FFF',
    fontSize: 16,
    fontWeight: '900',
    letterSpacing: 1,
  },
  switchText: {
    color: theme.colors.accent,
    fontSize: 13,
    textAlign: 'center',
    marginTop: 18,
  },
});
